import { Component, OnInit, ViewChild, ElementRef, Renderer2, AfterViewInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-view-help',
  templateUrl: './view-help.component.html',
  styleUrls: ['./view-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewHelpComponent implements OnInit, AfterViewInit {
  // ---------- Child Elements ----------
  @ViewChild('viewHelp', { static: true })
  viewHelp: ElementRef;



  // ---------- Observables ---------
  @Select(ViewState.getCanTouch)
  canTouch$: Observable<boolean>;



  // ---------- Class Variables ----------
  activeTab: 'basics' | 'all' = 'basics';



  // ---------- Layout ----------
  constructor(
    private renderer: Renderer2,
    private viewService: ViewService
  ) { }

  ngOnInit() {
    this.initWindowSizeObserver();
  }

  ngAfterViewInit() {
    this.updateViewHeight();
  }


  
  // ---------- Layout ----------
  initWindowSizeObserver() {
    this.renderer.listen('window', 'resize', () => {
      this.updateViewHeight();
    });
  }

  // Mobile devices have variable viewheight because the browser bar can scroll in and out of view
  // This workaround determines the available window space and uses that as a viewheight unit
  updateViewHeight() {
    const vh = window.innerHeight * 0.01;
    this.viewHelp.nativeElement.style.setProperty('--vh', `${vh}px`);
  }



  // ---------- Interactions ----------
  handleCloseClick() {
    this.viewService.toggleHelp(false);
  }

  handleTabClick(tab: 'basics' | 'all') {
    this.activeTab = tab;
  }

}
